import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from 'shared/lib/classNames/classNames';
import cls from './Layout.module.scss';
export var Layout = function (props) {
    var className = props.className, sidebarSlot = props.sidebarSlot, headerSlot = props.headerSlot, pageSlot = props.pageSlot, footerSlot = props.footerSlot;
    return (_jsxs("div", { className: classNames(cls.Layout, {}, [className]), children: [_jsxs("div", { className: cls.container, children: [sidebarSlot, _jsxs("div", { className: cls.content, children: [headerSlot, _jsx("main", { className: cls.main, children: pageSlot })] })] }), footerSlot] }));
};
